const numbers = '\\d+(?:[\\.,]\\d+)?';
const weekPattern = '(' + numbers + 'W)';
const datePattern = '(' + numbers + 'Y)?(' + numbers + 'M)?(' + numbers + 'D)?';
const timePattern =
	'T(' + numbers + 'H)?(' + numbers + 'M)?(' + numbers + 'S)?';

const iso8601 =
	'P(?:' + weekPattern + '|' + datePattern + '(?:' + timePattern + ')?)';
const objMap = [
	'weeks',
	'years',
	'months',
	'days',
	'hours',
	'minutes',
	'seconds',
];

const defaultDuration = {
	years: 0,
	months: 0,
	weeks: 0,
	days: 0,
	hours: 0,
	minutes: 0,
	seconds: 0,
};

const pattern = new RegExp(iso8601);

class Duration {
	static parse(durationString: string): any {
		// Slice away first entry in match-array
		return !durationString ? {} : durationString
			.match(pattern)
			?.slice(1)
			?.reduce((prev, next, idx) => {
				// @ts-ignore
				prev[objMap[idx]] = parseFloat(next) || 0;
				return prev;
			}, {});
	}

	static end(duration: any, startDate?: Date) {
		duration = Object.assign({}, defaultDuration, duration);

		// Create two equal timestamps, add duration to 'then' and return time difference
		var timestamp = startDate ? startDate.getTime() : Date.now();
		var then = new Date(timestamp);

		then.setFullYear(then.getFullYear() + duration.years);
		then.setMonth(then.getMonth() + duration.months);
		then.setDate(then.getDate() + duration.days);
		then.setHours(then.getHours() + duration.hours);
		then.setMinutes(then.getMinutes() + duration.minutes);
		// Then.setSeconds(then.getSeconds() + duration.seconds);
		then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1000);
		// Special case weeks
		then.setDate(then.getDate() + duration.weeks * 7);

		return then;
	}

	static toSeconds(duration: any, startDate?: Date) {
		duration = Object.assign({}, defaultDuration, duration);

		var timestamp = startDate ? startDate.getTime() : Date.now();
		var now = new Date(timestamp);
		var then = Duration.end(duration, now);

		var seconds = (then.getTime() - now.getTime()) / 1000;
		return seconds;
	}
}

export default Duration;

export const formatAsHHMM = (sec: any) => {
	let sec_num = parseInt(sec, 10); // don't forget the second param
	let hours: any = Math.floor(sec_num / 3600);
	let minutes: any = Math.floor((sec_num - hours * 3600) / 60);

	// let seconds: any = sec_num - (hours * 3600) - (minutes * 60);

	if (hours < 10) {
		hours = '0' + hours;
	}
	if (minutes < 10) {
		minutes = '0' + minutes;
	}

	// if (seconds < 10) {seconds = "0"+seconds;}
	return hours + ':' + minutes;
};
